export default "__VITE_ASSET__082bf953__"